import { pointrules } from "./config";

const getTieScores = (rubbers, sport, pointrulesExtra) => {
  const filterpointrules = pointrules.filter((r) => r.sport === sport.toLowerCase())
  let pointrule = null
  if (filterpointrules.length === 0) {
    console.error('No pointrule found for sport:', sport, 'and rubbers:', rubbers.length)
    return { homegames: 0, awaygames: 0, homepoints: 0, awaypoints: 0 }
  } else if (filterpointrules.length === 1) {
    pointrule = filterpointrules[0]
  } else if (filterpointrules.length > 1) {
    pointrule = filterpointrules.find((r) => r.rubbers === rubbers.length)
  }
  if (!pointrule) {
    console.error('No pointrule found for sport:', sport, 'and rubbers:', rubbers.length)
    return { homegames: 0, awaygames: 0, homepoints: 0, awaypoints: 0, homesets: 0, awaysets: 0 }
  }
  if (pointrulesExtra) {
    // Override pointrule with extra settings if provided
    pointrule = { ...pointrule, ...pointrulesExtra }
  }
  const diffs = rubbers.reduce(
    (ac, cu) => {
      if (cu.score) {
        console.log('cu.score', cu.score)
        let homeoverride = false
        if (typeof cu.homestandingoverride !== 'undefined') {
          ac.homepoints = ac.homepoints + cu.homestandingoverride
          homeoverride = true
        }
        let awayoverride = false
        if (typeof cu.awaystandingoverride !== 'undefined') {
          ac.awaypoints = ac.awaypoints + cu.awaystandingoverride
          awayoverride = true
        }

        const scores = cu.score.reduce(
          (acs, cs, index) => {
            if (index === 2 && pointrule.lastsetgames === 1) {
              if (cs.home > cs.away) {
                acs.homegames = acs.homegames + 1
              } else {
                acs.awaygames = acs.awaygames + 1
              }
            } else {
              acs.homegames = acs.homegames + cs.home
              acs.awaygames = acs.awaygames + cs.away
            }
            if (cs.home > cs.away) {
              if (!homeoverride) acs.homepoints = acs.homepoints + pointrule.setwin
            } else if (cs.home < cs.away) {
              if (!awayoverride) acs.awaypoints = acs.awaypoints + pointrule.setwin
            } else {
              if (!homeoverride) acs.homepoints = acs.homepoints + pointrule.setdraw
              if (!awayoverride) acs.awaypoints = acs.awaypoints + pointrule.setdraw
            }
            if (cs.home > cs.away) {
              acs.homesets = acs.homesets + 1
            } else if (cs.home < cs.away) {
              acs.awaysets = acs.awaysets + 1
            }
            return acs
          },
          { homegames: 0, awaygames: 0, homepoints: 0, awaypoints: 0, homesets: 0, awaysets: 0 }
        )


        ac.homegames = ac.homegames + scores.homegames
        ac.awaygames = ac.awaygames + scores.awaygames
        ac.homepoints = ac.homepoints + scores.homepoints
        ac.awaypoints = ac.awaypoints + scores.awaypoints
        ac.homesets = ac.homesets + scores.homesets
        ac.awaysets = ac.awaysets + scores.awaysets
        if (pointrule.clearwin) {
          if (scores.homepoints === 0) {
            if (!awayoverride) ac.awaypoints = ac.awaypoints + pointrule.clearwin
          } else if (scores.awaypoints === 0) {
            if (!homeoverride) ac.homepoints = ac.homepoints + pointrule.clearwin
          }
        }
      }
      return ac
    },
    { homegames: 0, awaygames: 0, homepoints: 0, awaypoints: 0, homesets: 0, awaysets: 0 }
  )
  return diffs
}

export { getTieScores }